import { render, staticRenderFns } from "./FullscreenToggle.vue?vue&type=template&id=2b78239f&"
import script from "./FullscreenToggle.vue?vue&type=script&lang=js&"
export * from "./FullscreenToggle.vue?vue&type=script&lang=js&"
import style0 from "./FullscreenToggle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b78239f')) {
      api.createRecord('2b78239f', component.options)
    } else {
      api.reload('2b78239f', component.options)
    }
    module.hot.accept("./FullscreenToggle.vue?vue&type=template&id=2b78239f&", function () {
      api.rerender('2b78239f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FullscreenToggle.vue"
export default component.exports